import ajax from '../ajax';
import web from '../web';

const STATUS_PENDING = 1;
const STATUS_CONFIRMED = 2;
const STATUS_COMPLETED = 3;
const STATUS_MISSED = 4;
const STATUS_CANCELED = 5;

async function fetchAppointments() {
    const response = await web.get('admin/appointments');
    return response.data;
}

async function fetchAppointment(id) {
    const response = await ajax.get(`appointments/${id}`);
    return response.data;
}

async function createAppointment(fields) {
    const response = await web.post('appointments', fields);
    return response.data;
}

async function updateAppointment(id) {
    const response = await web.put(`appointments/${id}`);
    return response.data;
}

async function getEasypayManifest(fields) {
    const response = await ajax.post(`checkout`, fields);
    return response.data;
}

export { STATUS_PENDING, STATUS_CONFIRMED, STATUS_COMPLETED, STATUS_MISSED, STATUS_CANCELED, fetchAppointments, fetchAppointment, createAppointment, updateAppointment, getEasypayManifest };
